import {
  setImpersonatedUserEmail,
  useImpersonatedUserEmail,
} from "../../stores/impersonatedUser.store.ts";
import {
  AutoComplete,
  AutoCompleteInput,
  AutoCompleteItem,
  AutoCompleteList,
} from "@choc-ui/chakra-autocomplete";
import { Flex, CloseButton } from "@chakra-ui/react";
import { useEffect, useRef } from "react";

export const UserSelectCombobox = ({
  users,
}: {
  users: Array<{ value: string; label: string }>;
}) => {
  const ref = useRef(null);
  const impersonatedUser = useImpersonatedUserEmail();
  useEffect(() => {
    const label = users?.find((x) => x.value === impersonatedUser)?.label ?? "";
    if (impersonatedUser && !label) {
      ref.current.removeItem(impersonatedUser);
      setImpersonatedUserEmail(null);
    }
  }, [impersonatedUser]);

  return (
    <Flex alignItems="center" gap={2}>
      <AutoComplete
        key={impersonatedUser}
        ref={ref}
        openOnFocus
        value={
          impersonatedUser
            ? (users?.find((x) => x.value === impersonatedUser)?.label ?? "")
            : ""
        }
        onChange={(e) => {
          setImpersonatedUserEmail(e);
        }}
      >
        <AutoCompleteInput
          w={255}
          placeholder={"Impersonate User"}
          bg={"bg.panel"}
        />
        <AutoCompleteList>
          {users
            .sort((a, b) => (a.label > b.label ? 1 : -1))
            .map((user, cid) => (
              <AutoCompleteItem
                key={`option-${cid}`}
                value={user.value}
                textTransform="capitalize"
              >
                {user.label}
              </AutoCompleteItem>
            ))}
        </AutoCompleteList>
      </AutoComplete>
      {impersonatedUser && (
        <CloseButton
          size="sm"
          onClick={() => {
            ref.current.removeItem(impersonatedUser);
            setImpersonatedUserEmail(null);
          }}
        />
      )}
    </Flex>
  );
};
